/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib — the DOM scope a classic body-click dropdown handler may close in
 *   uses:      -
 *   siblings:  components/bb-modal-modern.{hbs,js} (owns the dialog class below)
 *   consumers: beebee-base-template routes/application.js, apps/e-commerce and
 *              apps/beebee-scuola-sci-maestro routes/application.js (body handlers)
 *   gotchas:   a click inside a BbModalModern dialog bubbles to <body> (the dialog
 *              no longer stops propagation, else every data-toggle opener inside a
 *              modal was dead). That click must only close the dropdowns OF THAT
 *              DIALOG: a pane outside it (often the one the modal was opened from)
 *              stayed open before the change and must stay open after it.
 *
 * Classic dropdowns (`[data-toggle]` opener + `.data-dropdown` pane) are opened and
 * closed by a single <body> click listener. This module tells that listener where
 * "close everything" applies for a given click.
 */

/** The BbModalModern dialog box (not the backdrop overlay around it). */
const MODAL_DIALOG_SELECTOR = '.beebee-modal-modern-dialog';

/**
 * The element whose dropdowns a click on `target` may close: the BbModalModern
 * dialog that contains it, or null for "the whole document".
 *
 * @param {EventTarget|null} target
 * @returns {Element|null}
 */
function dropdownScopeOf(target) {
  return target instanceof Element ? target.closest(MODAL_DIALOG_SELECTOR) : null;
}

/**
 * Every element matching `selector` inside `scope` (the document when null).
 *
 * @param {Element|null} scope
 * @param {string} selector
 * @returns {NodeListOf<Element>}
 */
function dropdownsIn(scope, selector) {
  return (scope ?? document).querySelectorAll(selector);
}

export { MODAL_DIALOG_SELECTOR, dropdownScopeOf, dropdownsIn };
//# sourceMappingURL=dropdown-scope.js.map
